"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableService = void 0;
const routes_1 = require("./routes");
class TableService {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    async create(data) {
        const result = await this.axiosInstance.post(routes_1.postTableRoute, data);
        return result.data;
    }
    async requestTablesByQueues(data) {
        const result = await this.axiosInstance.post(routes_1.postTableRoute + '/request/byQueues', data);
        return result.data;
    }
    async getOneById(id) {
        const result = await this.axiosInstance.get(routes_1.getTableRoute + id);
        return result.data;
    }
    async patch(id, data) {
        const result = await this.axiosInstance.patch(routes_1.getTableRoute + id, data);
        return result.data;
    }
    async delete(id) {
        const result = await this.axiosInstance.delete(routes_1.getTableRoute + id);
        return result.data;
    }
}
exports.TableService = TableService;
//# sourceMappingURL=index.js.map